import ev from "../util/enumValue";

enum PromotionState {
    UNAVAILABLE = ev('UNAVAILABLE', 0),
    AVAILABLE = ev('AVAILABLE', 1)
}

export default PromotionState;
